<!-- <div>
    <h6>ALL</h6>
</div> -->

<div class="d-flex justify-content-between">
    <div [ngClass]="{ 'title-width-mobile': isMobile, 'title-width': !isMobile }" [attr.id]="'gyan-title'" [attr.data-test]="'gyan-title'">
        <h3 class="main-header">{{ gyanTitle }}</h3>
    </div>
    <div
        *ngIf="isChatGPTSummary && !isMobile && isRapid"
        class="info-button cursor-pointer"
        (mouseenter)="showTooltipFunction(true)"
        (mouseleave)="showTooltipFunction(false)"
    ></div>
    <div
        *ngIf="isChatGPTSummary && isMobile && isRapid"
        [ngClass]="{ 'info-button-mobile': !displayTooltip, 'info-button-mobile-hover': displayTooltip }"
        class="cursor-pointer"
        (click)="displaytooltipMobile()"
        clickOutside
        (clickOutside)="hideTooltip()"
    ></div>
    <!-- Add a condition with isRapid flag based on the status of gyan -->
    <!-- || !topicType -->
    <div *ngIf="!isRapid && !isMobile" class="progress-position">
        <div class="d-flex" *ngIf="!isRapid && gyanrunning">
            <div class="pr-5p">Synthesis in progress</div>
            <div><img class="process-icon" src="./../assets/gifs/process.gif" /></div>
        </div>
        <div class="d-flex" *ngIf="!isRapid && gyanfailed">
            <div class="pr-5p">Gyan process failed</div>
            <div class="fail-icon"></div>
        </div>
    </div>
    <div *ngIf="!isRapid" class="progress-position">
        <div class="d-flex" *ngIf="!isRapid && !gyanrunning && !gyanfailed">
            <div (click)="onButtonClick($event)" style="cursor: pointer" [ngClass]="{ active: menuOpen }" class="comment-box-items-export">
                <img *ngIf="!menuOpen" class="icon-export" title="Export" alt="Export" src="../../../assets/organisation/icon-export.svg" />
                <img *ngIf="menuOpen" class="icon-export" title="Export" alt="Export" src="../../../assets/organisation/icon-export-hover-active.svg" />
            </div>
        </div>
        <div *ngIf="menuOpen" class="options-box comment-box export-box">
            <div>
                <div class="col">
                    <div class="comment-box-items comment-box-items-word cursor-pointer col-auto align-items-center" (click)="gotoExport('word')">
                        <img class="align-items-center option-icon icon-word" src="../../../assets/organisation/icon-word.svg" alt="Refresh icon" />
                        <span class="menu-item"> Export as Word</span>
                    </div>
                    <div class="divider"></div>
                    <div class="comment-box-items comment-box-items-pdf cursor-pointer col-auto align-items-center" (click)="gotoExport('pdf')">
                        <img class="align-items-center option-icon icon-pdf" src="../../../assets/organisation/icon-pdf.svg" alt="Export icon" />
                        <span class="menu-item"> Export as PDF</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="!isRapid && topicType && isMobile" class="progress-position-mobile">
    <div class="d-flex" *ngIf="gyanrunning">
        <span class="pr-5p">Synthesis in progress</span>
        <span class="mt-3p"><img class="process-icon" src="./../assets/gifs/process.gif" /></span>
    </div>
    <div class="d-flex" *ngIf="gyanfailed">
        <span class="pr-5p">Gyan process failed</span>
        <span class="fail-icon mt-2p"></span>
    </div>
</div>
<div *ngIf="loading" class="multi-doc-summary-section h-100">
    <ng-scrollbar visibility="hover" [pointerEventsDisabled]="true">
        <!-- <h3 class="heading-skeleton skeleton-placeholder"></h3> -->
        <div class="my-4">
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-25 paragraph-line-skeleton skeleton-placeholder"></div>
        </div>
        <div class="my-4">
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-75 paragraph-line-skeleton skeleton-placeholder"></div>
            <!-- display the below div only if summary is not available -->
            <!-- Removed below line because we no longer show generic summary not available message -->
            <div
                [ngClass]="{
                    'no-summary-message': !isMobile && gyanType === 'rapid',
                    'no-summary-message-gyan': !isMobile && gyanType === 'gyan',
                    'no-summary-message-mobile': isMobile,
                }"
                *ngIf="summaryNotAvailable"
            >
                <!-- || (summaryNotAvailable && !showPKSPermission) -->
                Summary is not available
            </div>
            <!-- display the below div only if summary is loading -->
            <div
                class="d-flex"
                [ngClass]="{
                    'loading-summary-message': !isMobile && gyanType === 'rapid',
                    'loading-summary-message-gyan': !isMobile && gyanType === 'gyan',
                    'loading-summary-message-mobile': isMobile,
                }"
                *ngIf="!summaryNotAvailable"
            >
                <div class="padding-summary">{{ loaderMessage }}</div>
                <div><img src="./../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
            </div>
        </div>
        <div class="my-4">
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-50 paragraph-line-skeleton skeleton-placeholder"></div>
        </div>
        <div class="my-4">
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-50 paragraph-line-skeleton skeleton-placeholder"></div>
        </div>
        <div class="my-4" *ngIf="isMobile">
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-25 paragraph-line-skeleton skeleton-placeholder"></div>
        </div>
        <div class="my-4" *ngIf="isMobile">
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-25 paragraph-line-skeleton skeleton-placeholder"></div>
        </div>
    </ng-scrollbar>
</div>
<div class="multi-doc-summary-section h-100">
    <div [ngClass]="{ 'tooltip-gpt-mobile': isMobile, 'tooltip-gpt': !isMobile }" *ngIf="showtooltip || displayTooltip">
        <span>
            {{ chatGptSummary }}
        </span>
    </div>
    <div *ngIf="!loading && rapidGyan" class="multi-doc-summary" [attr.id]="'multi-doc-summary'" [attr.data-test]="'multi-doc-summary'">
        <ng-scrollbar visibility="hover" [pointerEventsDisabled]="true">
            <ul>
                <li *ngFor="let para of multidocsummary">
                    <p
                        class="text-justify"
                        [ngClass]="{ 'highlighted-summary': para.id == selectedPara && para.id != '', 'cursor-pointer': isClickable }"
                        (click)="isClickable ? selectPara(para.id, para.sentenceIds) : null"
                    >
                        {{ para.text }}
                    </p>
                </li>
            </ul>
            <!-- <ngx-typed-js [typeSpeed]="0" [showCursor]="false" [strings]="[multidocsummary]">
                <div class="typing" (click)="selectPara()"></div>
            </ngx-typed-js> -->
        </ng-scrollbar>
    </div>
    <div *ngIf="!loading && !rapidGyan" class="multi-doc-summary" [attr.id]="'multi-doc-summary'" [attr.data-test]="'multi-doc-summary'">
        <ng-scrollbar visibility="hover" [pointerEventsDisabled]="true">
            <!-- commented the below line because we are displaying summary now seperately(pks and other sources) -->
            <!-- <div *ngIf="!showPKSPermission">
                <ng-container *ngTemplateOutlet="summaryList; context: { $implicit: summaryDetail }"> </ng-container>
            </div> -->
            <ng-container>
                <ng-template #summaryList let-summaryDetail let-parentIndex="parentIndex">
                    <ng-container>
                        <div *ngFor="let summaryItem of summaryDetail; let i = index">
                            <ng-container>
                                <div class="d-flex mb-2 div-1">
                                    <div
                                        class="primary-color cursor-pointer"
                                        *ngIf="summaryItem.nextLevel"
                                        (click)="$event.stopPropagation(); expandCollapseIconClicked(summaryItem)"
                                    >
                                        <div *ngIf="!summaryItem.isExpanded" title="Expand" class="pr-2">
                                            <fa-icon class="float-end" [icon]="faAngleRight"></fa-icon>
                                        </div>
                                        <div *ngIf="summaryItem.isExpanded" title="Collapse" class="pr-2">
                                            <fa-icon class="float-end" [icon]="faAngleDown"></fa-icon>
                                        </div>
                                    </div>
                                    <span *ngIf="!summaryItem.nextLevel" class="pr-2">-</span>
                                    <span
                                        *ngIf="isSentenceClickable"
                                        class="cursor-pointer"
                                        (click)="clickback(summaryItem.id)"
                                        [ngClass]="{ 'highlighted-summary': summaryItem.id == selectedParaId }"
                                        [innerHTML]="summaryItem.summaryText"
                                        [attr.id]="'mdm-summary-data-' + (parentIndex !== null ? parentIndex + '-' : '') + i"
                                        [attr.data-test]="'mdm-summary-data-' + (parentIndex !== null ? parentIndex + '-' : '') + i"
                                    ></span>
                                    <span *ngIf="!isSentenceClickable" [innerHTML]="summaryItem.summaryText"></span>
                                </div>
                                <div *ngIf="summaryItem.nextLevel && summaryItem.isExpanded" class="ml-3">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            summaryList;
                                            context: { $implicit: summaryItem.children, parentIndex: (parentIndex !== null ? parentIndex + '-' : '') + i }
                                        "
                                    >
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </ng-template>
            </ng-container>
            <!-- <div *ngIf="showPKSPermission"> -->
            <div>
                <!-- <div *ngIf="knowledgedStoreSummeries.length > 0"> -->
                <!-- <h2 class="summary-header" *ngIf="knowledgedStoreSummeries.length > 0 && articalSummeries.length > 0">Synopsis from Primary Knowledge Store</h2> -->
                <h2 class="summary-header" *ngIf="headerDisplayParams.hasPKSSource">Synopsis from Primary Knowledge Store</h2>
                <!-- <h2 class="summary-header" *ngIf="knowledgedStoreSummeries.length > 0">Synopsis from Primary Knowledge Store</h2> -->

                <ng-container *ngTemplateOutlet="summaryList1; context: { $implicit: knowledgedStoreSummeries, parentIndex: null }"> </ng-container>
            </div>
            <ng-container>
                <ng-template #summaryList1 let-knowledgedStoreSummeries let-parentIndex="parentIndex">
                    <!-- <ng-container *ngIf="knowledgedStoreSummeries.length > 0"> -->
                    <ng-container *ngIf="headerDisplayParams.hasSummaryFromPKSSource">
                        <ng-container>
                            <div *ngFor="let summaryItem of knowledgedStoreSummeries; let i = index">
                                <ng-container>
                                    <div class="d-flex mb-2 div-1">
                                        <div
                                            class="primary-color cursor-pointer"
                                            *ngIf="summaryItem.nextLevel"
                                            (click)="$event.stopPropagation(); expandCollapseIconClicked(summaryItem)"
                                        >
                                            <div *ngIf="!summaryItem.isExpanded" title="Expand" class="pr-2">
                                                <fa-icon class="float-end" [icon]="faAngleRight"></fa-icon>
                                            </div>
                                            <div *ngIf="summaryItem.isExpanded" title="Collapse" class="pr-2">
                                                <fa-icon class="float-end" [icon]="faAngleDown"></fa-icon>
                                            </div>
                                        </div>
                                        <span *ngIf="!summaryItem.nextLevel" class="pr-2">-</span>
                                        <span
                                            *ngIf="isSentenceClickable"
                                            class="cursor-pointer"
                                            (click)="clickback(summaryItem.id)"
                                            [ngClass]="{ 'highlighted-summary': summaryItem.id == selectedParaId }"
                                            [innerHTML]="summaryItem.summaryText"
                                            [attr.id]="'mdm-summary-pks-data-' + (parentIndex !== null ? parentIndex + '-' : '') + i"
                                            [attr.data-test]="'mdm-summary-pks-data-' + (parentIndex !== null ? parentIndex + '-' : '') + i"
                                        ></span>
                                        <span *ngIf="!isSentenceClickable" [innerHTML]="summaryItem.summaryText"></span>
                                    </div>
                                    <div *ngIf="summaryItem.nextLevel && summaryItem.isExpanded" class="ml-3">
                                        <ng-container
                                            *ngTemplateOutlet="
                                                summaryList1;
                                                context: { $implicit: summaryItem.children, parentIndex: (parentIndex !== null ? parentIndex + '-' : '') + i }
                                            "
                                        >
                                        </ng-container>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                    </ng-container>
                    <!-- <ng-container *ngIf="knowledgedStoreSummeries.length == 0"> -->
                    <ng-container *ngIf="headerDisplayParams.hasPKSSource && !headerDisplayParams.hasSummaryFromPKSSource && checkGyanStatus()">
                        <!-- There wasn’t sufficient relevant content in the source/s selected for Gyan to generate a summary. -->
                        There wasn’t sufficient relevant content in your Primary Knowledge Store for Gyan to generate a summary.
                    </ng-container>
                    <!-- <ng-container *ngIf="!headerDisplayParams.hasPKSSource && !headerDisplayParams.hasSummaryFromPKSSource && checkGyanStatus()">
                        There wasn’t sufficient relevant content in your Primary Knowledge Store for Gyan to generate a summary.
                    </ng-container> -->
                    <ng-container *ngIf="headerDisplayParams.hasPKSSource && !headerDisplayParams.hasSummaryFromPKSSource && !checkGyanStatus()">
                        <!-- There wasn’t sufficient relevant content in the source/s selected for Gyan to generate a summary. -->
                        Highlights from Primary Knowledge Store being compiled...
                    </ng-container>
                </ng-template>
            </ng-container>
            <!-- <hr *ngIf="knowledgedStoreSummeries.length > 0 && articalSummeries.length > 0" class="divider my-4" /> -->
            <hr class="divider my-4" *ngIf="headerDisplayParams.hasPKSSource && headerDisplayParams.hasOtherSources" />

            <!-- Add the showPKSPermission permission if needed -->
            <!-- <div *ngIf="showPKSPermission"> -->
            <div>
                <!-- <div *ngIf="articalSummeries.length > 0"> -->
                <!-- <h2 class="summary-header" *ngIf="knowledgedStoreSummeries.length > 0 && articalSummeries.length > 0">Highlights from other selected sources</h2> -->
                <!-- <h2 class="summary-header" *ngIf="articalSummeries.length > 0">Highlights from other selected sources</h2> -->

                <h2 class="summary-header" *ngIf="headerDisplayParams.hasOtherSources">Highlights from other selected sources</h2>
                <ng-container *ngTemplateOutlet="summaryList2; context: { $implicit: articalSummeries, parentIndex: null }"> </ng-container>
            </div>
            <ng-container>
                <ng-template #summaryList2 let-articalSummeries let-parentIndex="parentIndex">
                    <!-- <ng-container *ngIf="articalSummeries.length > 0"> -->
                    <ng-container *ngIf="headerDisplayParams.hasSummaryFromOtherSource">
                        <ng-container>
                            <div *ngFor="let summaryItem of articalSummeries; let i = index">
                                <ng-container>
                                    <div class="d-flex mb-2 div-1">
                                        <div
                                            class="primary-color cursor-pointer"
                                            *ngIf="summaryItem.nextLevel"
                                            (click)="$event.stopPropagation(); expandCollapseIconClicked(summaryItem)"
                                        >
                                            <div *ngIf="!summaryItem.isExpanded" title="Expand" class="pr-2">
                                                <fa-icon class="float-end" [icon]="faAngleRight"></fa-icon>
                                            </div>
                                            <div *ngIf="summaryItem.isExpanded" title="Collapse" class="pr-2">
                                                <fa-icon class="float-end" [icon]="faAngleDown"></fa-icon>
                                            </div>
                                        </div>
                                        <span *ngIf="!summaryItem.nextLevel" class="pr-2">-</span>
                                        <span
                                            *ngIf="isSentenceClickable"
                                            class="cursor-pointer"
                                            (click)="clickback(summaryItem.id)"
                                            [ngClass]="{ 'highlighted-summary': summaryItem.id == selectedParaId }"
                                            [innerHTML]="summaryItem.summaryText"
                                            [attr.id]="'mdm-summary-other-source-data-' + (parentIndex !== null ? parentIndex + '-' : '') + i"
                                            [attr.data-test]="'mdm-summary-other-source-data-' + (parentIndex !== null ? parentIndex + '-' : '') + i"
                                        ></span>
                                        <span *ngIf="!isSentenceClickable" [innerHTML]="summaryItem.summaryText"></span>
                                    </div>
                                    <div *ngIf="summaryItem.nextLevel && summaryItem.isExpanded" class="ml-3">
                                        <ng-container
                                            *ngTemplateOutlet="
                                                summaryList2;
                                                context: { $implicit: summaryItem.children, parentIndex: (parentIndex !== null ? parentIndex + '-' : '') + i }
                                            "
                                        >
                                        </ng-container>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                    </ng-container>
                    <!-- <ng-container *ngIf="articalSummeries.length == 0"> -->
                    <ng-container *ngIf="headerDisplayParams.hasOtherSources && !headerDisplayParams.hasSummaryFromOtherSource && checkGyanStatus()">
                        There wasn’t sufficient relevant content in the source/s selected for Gyan to generate a summary.
                    </ng-container>
                    <ng-container *ngIf="headerDisplayParams.hasOtherSources && !headerDisplayParams.hasSummaryFromOtherSource && !checkGyanStatus()">
                        Highlights from other sources being compiled...
                    </ng-container>
                </ng-template>
            </ng-container>
        </ng-scrollbar>
    </div>
</div>
<!-- <p>{{ 'multidocsummary' | translate }}</p> -->
